module.exports = __webpack_public_path__ + "72b2fd168e6d5e2803cb128583e9b0ee.png";


//////////////////
// WEBPACK FOOTER
// ./public/pic2@2x.png
// module id = 209
// module chunks = 1